/* global $ */
// 修正依頼モーダル機能
document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('revisionRequestModal');
  if (!modal) {
    console.log('Modal not found');
    return;
  }

  const revisionContentTextarea = document.getElementById('revision_content');
  const emailPreview = document.getElementById('email-preview');
  
  if (!revisionContentTextarea || !emailPreview) {
    console.log('Required elements not found:', {
      textarea: !!revisionContentTextarea,
      preview: !!emailPreview
    });
    return;
  }

  // データ属性から値を取得（XSS対策）
  const siteName = modal.dataset.siteName;
  const siteUrl = modal.dataset.siteUrl;
  
  console.log('サイトデータ:', { siteName, siteUrl });
  
  // メールテンプレートの基本構造
  function generateEmailPreview(revisionContent) {
    const hasRevisionContent = revisionContent && revisionContent.trim().length > 0;
    
    return `平素より${siteName}をご利用いただきありがとうございます。

    このたびは、出資者情報の審査にご協力いただき、誠にありがとうございます。

    審査の結果、ご登録いただいた出資者情報について、修正が必要な箇所がございます。
    お手数をおかけいたしますが、下記のマイページにアクセスして修正をお願いいたします。

    ${hasRevisionContent ? `【修正が必要な内容】
    ${revisionContent}

    ` : ''}【マイページ（アカウント情報）】
    ${siteUrl}

    ※マイページにログイン後、「ユーザー情報の変更」から該当項目を修正してください。

    修正が完了しましたら、再度審査を行わせていただきます。
    審査完了後、改めてご連絡させていただきます。

    ご不明な点がございましたら、お気軽にお問い合わせください。

    今後とも${siteName}をよろしくお願いいたします。`;
  }
  
  // プレビューを更新する関数
  function updatePreview() {
    const revisionContent = revisionContentTextarea.value;
    const previewContent = generateEmailPreview(revisionContent);
    emailPreview.textContent = previewContent;
    console.log('プレビュー更新完了');
  }
  
  // 文字数カウント機能
  function updateCharCount() {
    const content = revisionContentTextarea.value;
    const charCount = content.length;
    const charCountElement = document.getElementById('charCount');
    
    if (charCountElement) {
      charCountElement.textContent = charCount;
      
      // 文字数が制限に近づいたら警告表示
      if (charCount > 1200) {
        charCountElement.style.color = 'red';
      } else if (charCount > 1000) {
        charCountElement.style.color = 'orange';
      } else {
        charCountElement.style.color = 'inherit';
      }
    }
  }

  // 初期プレビューを表示
  updatePreview();
  updateCharCount();

  // テキストエリアの変更を監視してリアルタイム更新
  revisionContentTextarea.addEventListener('input', function() {
    updatePreview();
    updateCharCount();
  });
  
  // モーダルが開かれたときにプレビューと文字数カウントを更新
  if (typeof $ !== 'undefined') {
    $(modal).on('shown.bs.modal', function() {
      updatePreview();
      updateCharCount();
    });
  } else {
    // jQuery が利用できない場合のフォールバック
    modal.addEventListener('shown.bs.modal', function() {
      updatePreview();
      updateCharCount();
    });
  }
});
